/**
 * Shell común de las páginas legales (Sprint 14 S14.2 — R1 GDPR).
 *
 * Contenedor legible en columna estrecha, fondo grafito, con enlaces de
 * "volver" arriba y abajo. El título del documento ya viene como `# ...` en
 * el propio markdown, así que aquí no se duplica.
 */
import { Link } from "react-router-dom";

import { t } from "@/i18n/es";

import { LegalMarkdown } from "./LegalMarkdown";

interface Props {
  /** Markdown verbatim del documento (de src/content/legal.ts). */
  source: string;
  /** data-testid de la página (privacy-page / terms-page). */
  testId: string;
}

export function LegalDocument({ source, testId }: Props) {
  return (
    <main
      data-testid={testId}
      className="mx-auto min-h-app max-w-2xl bg-graphite px-6 py-12 text-bone"
    >
      <Link
        to="/login"
        className="text-xs text-bone-muted underline-offset-4 hover:text-bone hover:underline"
      >
        {t.legal.back}
      </Link>

      <article className="mt-6">
        <LegalMarkdown source={source} />
      </article>

      <div className="mt-12">
        <Link
          to="/login"
          className="text-xs text-bone-muted underline-offset-4 hover:text-bone hover:underline"
        >
          {t.legal.back}
        </Link>
      </div>
    </main>
  );
}
